
import { Vue, Options } from 'vue-class-component'

@Options({
    data() {
        return {
            usernamefieldR: "",
            userpasswordfieldR: "",
            userfirstname: "",
            userlastname: "",
            useremail: "",
            SuccessR: "",
            ErrorR: ""
        };
    },
    methods: {
        register_user: function () {
            let url = "https://feedbacks-backend.herokuapp.com/api/auth/register/";
            let body = {
                "username": this.usernamefieldR,
                "password": this.userpasswordfieldR,
                "first_name": this.userfirstname,
                "last_name": this.userlastname,
                "email": this.useremail
            }
            console.log(body)

            fetch(
                url, {
                method: 'POST',
                headers: {
                    "accept": "application/json",
                    "Content-Type": "application/json; charset=utf8"
                },
                body: JSON.stringify(body)
            }
            ).then(
                response => {
                    return response.json()
                }
            ).then(
                data => {
                    if (data['error'] == 'true') {
                        localStorage.setItem('status', 'loggedout');
                        this.ErrorR = data['message'];
                    }
                    else {
                        let innerData = data['data'];
                        localStorage.setItem('userusername', innerData['username']);
                        localStorage.setItem('access', innerData['access']);
                        localStorage.setItem('refresh', innerData['refresh']);
                        localStorage.setItem('userfullname', innerData['first_name'] + innerData['last_name']);
                        localStorage.setItem('useremail', innerData['email']);
                        localStorage.setItem('status', 'loggedin');
                        this.SuccessR = data['message'];
                        setTimeout(this.$router.push('/'), 2000);
                    }
                }
            ).catch(error => {
                console.error(error);
            })
        },


    }
})


export default class Register extends Vue { }

